<template>
  <div class="x-misscenlist-box" style="margin:15px;text-align:left;">
    <el-form :inline="true" :model="ruleForm" class="demo-form-inline" :rules="rules" ref="ruleForm">
      <el-form-item label="请选择日期范围" prop="date1">
        <el-date-picker
          v-model="ruleForm.time"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="getdete('ruleForm')">下载</el-button> -->
        <a @click="getdete" :href="turl" class="x-perbtn-up">下载</a>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'datacenter5',
  data () {
    return {
      ruleForm:{
        time:''
      },
      rules:{
        date1:[
          // {required:true,message:'请选择起止时间',trigger:'blur'}
        ]
      },
      begintime:'',
      overtime:'',
      turl:''
    }
  },
  created() {

  },
  mounted(){

  },
  methods:{
    getdete:function(formName){
      console.log(this.ruleForm.time);
      let starttime = this.ruleForm.time[0]
      let endtime = this.ruleForm.time[1]
      //时间转时间戳
     var date = new Date(starttime);
     this.begintime = Date.parse(date) / 1000;
     console.log('任务期限开始时间戳：'+this.begintime);

      var date2 = new Date(endtime);
      this.overtime = Date.parse(date2) / 1000;
      console.log('任务期限结束时间戳：'+this.overtime);
      this.goup()

    },
    goup:function(){
      this.turl = "http://peixun.dlbbdk.com/admin/spc/note?sec=" + localStorage.token + "&startTime=" + this.begintime+ "&endTime=" + this.overtime
      console.log("http://peixun.dlbbdk.com/admin/spc/note?sec=" + localStorage.token + "&startTime=" + this.begintime+ "&endTime=" + this.overtime);
      // axios.get('/admin/spc/note', {
      //   params: {
      //     sec: localStorage.token,
      //     startTime:this.begintime,
      //     endTime:this.overtime
      //   }
      // })
      // .then(function (response) {
      //   console.log(response);
      //   if(response.data.status == 1){
      //
      //   }else{
      //     this.$message({
      //       showClose: true,
      //       message:response.data.msg ,
      //       type: 'error'
      //     });
      //   }
      // }.bind(this))
      // .catch(function (error) {
      //   console.log(error);
      // });
    }
  }
}
</script>

<style>
  .x-miss-tabbox .el-tabs__item{
    font-size: 16px;
  }.x-miss-tabbox .el-tabs__nav-wrap::after{
    height: 0;
  }.x-miss-tabbox .el-tabs__nav-wrap{
    margin-left: 10px;
  }.x-pagination{
    margin-top: 20px;
  }.x-misscenlist-box .el-table th.is-leaf{
    text-align: center;
  }.x-misscenlist-box .el-table thead tr th{
    background-color: #F2F2F2;
  }.x-misscenlist-box .el-table td{
    text-align: center;
  }.x-misscenlist-box .el-tabs__nav-wrap::after{
    height: 0;
  }.x-text-see{
    color: #BDA17A;
    text-decoration: none;

  }.x-ac-remove {
      background: url(../images/change.png)no-repeat;
      background-size: contain;
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      padding-left: 25px;
      margin-right: 20px;
  }.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
    cursor: pointer;
  }.x-miss-addbox{
    text-align: left;
    margin-bottom: 15px;
  }.el-form-item__content{
    text-align: left;
  }.x-all-btn {
      margin: 30px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn {
      background-color: #BDA17A;
      font-size: 14px;
      color: #fff;
      text-align: center;
      height: 44px;
      line-height: 44px;
      width: 126px;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      margin-right: 20px;
      z-index: 0;
  }.x-btn-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn-right .x-search-input{
    width: auto;
    margin-right: 10px;
    /* float: left; */
  }.x-miss-li{
    color: #333;
    cursor: pointer;
  }.x-bianji{
    /* background: url(../images/change.png)no-repeat; */
    background-size: contain;
    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 20px;
    display: initial;
    color: #BDA17A;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }.x-perbtn-up{
    text-decoration: none;
    color: #BDA17A;
    border: 1px solid #BDA17A;
    padding: 0 26px;
    height: 38px;
    line-height: 38px;
    display: inline-block;
    border-radius: 7px;
  }a.x-perbtn-up:hover{
    background-color: #BDA17A;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter5.vue